import { lazy } from 'react';

export const panelRegistry: Record<string, React.LazyExoticComponent<any>> = {
  'executive-overview': lazy(() => import('./executive/ExecutiveOverview')),
  'control-room-live': lazy(() => import('./executive/ControlRoomLive')),
  'ai-reporting': lazy(() => import('./executive/AIReportingAssistant')),

  'permit-risk': lazy(() => import('./opus/PermitRiskView')),
  'inspection-penalty': lazy(() => import('./opus/InspectionPenaltyExposure')),
  'reinstatement-dependency': lazy(() => import('./opus/ReinstatementDependency')),
  'lane-rental': lazy(() => import('./opus/LaneRentalTracker')),

  'works-planning': lazy(() => import('./core/WorksPlanningBoard')),
  'work-readiness': lazy(() => import('./core/WorkReadinessView')),
  'dispatch-screen': lazy(() => import('./core/DispatchScreen')),

  'mobile-job-list': lazy(() => import('./field/MobileJobList')),
  'job-detail': lazy(() => import('./field/JobDetail')),
  'field-readiness': lazy(() => import('./field/FieldReadiness')),

  'customer-journey': lazy(() => import('./customer/CustomerJourneyView')),
  'customer-risk': lazy(() => import('./customer/CustomerExperienceRisk')),
  'developer-services': lazy(() => import('./customer/DeveloperServicesJourney')),
  'community-portal': lazy(() => import('./customer/CommunityPortal')),

  'wastewater-workbank': lazy(() => import('./operations/WastewaterWorkbank')),
  'ai-control-room': lazy(() => import('./operations/AIControlRoom')),
  'tankering-dispatch': lazy(() => import('./operations/TankeringDispatch')),
  'waste-classification': lazy(() => import('./operations/WasteClassification')),

  'portfolio-delivery': lazy(() => import('./programme/PortfolioDelivery')),
  'contractor-performance': lazy(() => import('./programme/ContractorPerformance')),
  'scheme-health': lazy(() => import('./programme/SchemeHealth')),

  'evidence-chain': lazy(() => import('./compliance/EvidenceChain')),

  'sla-dashboard': lazy(() => import('./managed/SLADashboard')),
};
